// Polyfill localStorage for SSR/prerendering environment
if (typeof globalThis.localStorage === "undefined") {
  (globalThis as any).localStorage = {
    getItem: () => null,
    setItem: () => {},
    removeItem: () => {},
    clear: () => {},
    key: () => null,
    length: 0,
  };
}

import { renderToString } from "react-dom/server";

interface PrerenderData {
  url: string;
}

export async function prerender(data: PrerenderData) {
  // Dynamic import guarantees the polyfill above is set before app modules execute
  const { default: App } = await import("./App");
  const html = renderToString(<App url={data.url} />);

  return { html };
}
